const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/public/unsubscribe.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
const unsubscribeSearchSchema = z.object({
  skip_unsubscribe: z.coerce.boolean().optional().catch(undefined),
  unsubscribe_brief: z.coerce.boolean().optional().catch(undefined),
  token: z.string().optional().catch(undefined)
});
export const Route = createFileRoute("/public/unsubscribe")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: unsubscribeSearchSchema
});